var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"mt-4"},[_c('empty',{attrs:{"text":"This page does not exist"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }